<template>
	<div v-if="loading">
		<img :width="width" :src="asset('/images/loaderBalls.svg')">
		Loading...
	</div>
</template>

<script>
export default {
    name: 'Loader',

    props:{
        loading:{
            type: Boolean,
            required:true,
        },

        width:{
            type: Number,
            required: false,
            default: 65,
        }
    },

    data(){
        return{

        }
    },
}
</script>
